
export { default as Script } from "./Script"